"use strict";exports.__esModule = true;exports.default = void 0;var _makeupExpander = _interopRequireDefault(require("makeup-expander"));
var eventUtils = _interopRequireWildcard(require("../../common/event-utils"));
var _menuUtils = _interopRequireDefault(require("../../common/menu-utils"));function _getRequireWildcardCache(nodeInterop) {if (typeof WeakMap !== "function") return null;var cacheBabelInterop = new WeakMap();var cacheNodeInterop = new WeakMap();return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {return nodeInterop ? cacheNodeInterop : cacheBabelInterop;})(nodeInterop);}function _interopRequireWildcard(obj, nodeInterop) {if (!nodeInterop && obj && obj.__esModule) {return obj;}if (obj === null || typeof obj !== "object" && typeof obj !== "function") {return { default: obj };}var cache = _getRequireWildcardCache(nodeInterop);if (cache && cache.has(obj)) {return cache.get(obj);}var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {Object.defineProperty(newObj, key, desc);} else {newObj[key] = obj[key];}}}newObj.default = obj;if (cache) {cache.set(obj, newObj);}return newObj;}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _default =

Object.assign({}, _menuUtils.default, {
  toggleItemChecked(index, itemEl, originalEvent) {
    // This needs to be at start since toggleChecked swaps the checkedIndex
    // and then the right events will not fire correctly
    var shouldEmitRadio = this.isRadio() && index !== this.state.checkedIndex;
    this.toggleChecked(index);

    if (shouldEmitRadio) {
      if (this.input.collapseOnSelect) {
        this.expander.expanded = false;
      }
      this.emitComponentEvent({
        index,
        eventType: 'change',
        el: itemEl,
        originalEvent });

    } else if (this.type !== 'radio') {
      if (this.input.collapseOnSelect) {
        this.expander.expanded = false;
      }
      this.emitComponentEvent({
        index,
        eventType: !this.type ? 'select' : 'change',
        el: itemEl,
        originalEvent });

    }

    if (this.rovingTabindex) {
      this.tabindexPosition = this.rovingTabindex.filteredItems.findIndex(
      function (el) {return el.tabIndex === 0;});

    }
  },

  handleItemClick(index, e, itemEl) {
    this.toggleItemChecked(index, itemEl, e);
  },

  handleMenuKeydown(_ref) {var _this = this;var el = _ref.el,originalEvent = _ref.originalEvent,index = _ref.index;
    eventUtils.handleActionKeydown(originalEvent, function () {
      _this.handleItemClick(index, originalEvent, el);
    });

    eventUtils.handleEscapeKeydown(originalEvent, function () {
      _this.expander.expanded = false;
      _this.focus();
    });
  },

  focus() {
    this.getComponent('button').el.focus();
  },

  handleButtonEscape() {
    this.expander.expanded = false;
  },

  handleExpand() {
    this.emitComponentEvent({ eventType: 'expand' });
  },

  handleCollapse() {
    this.emitComponentEvent({ eventType: 'collapse' });
  },

  handleMenuChange(_ref2) {var el = _ref2.el,originalEvent = _ref2.originalEvent,index = _ref2.index;
    this.toggleItemChecked(index, el, originalEvent);
  },

  handleMenuSelect(_ref3) {var el = _ref3.el,originalEvent = _ref3.originalEvent,index = _ref3.index;
    if (this.input.collapseOnSelect) {
      this.expander.expanded = false;
    }

    this.emitComponentEvent({ eventType: 'select', el, originalEvent, index });
  },
  handleMousedown(_ref4) {var el = _ref4.el,originalEvent = _ref4.originalEvent;
    this.emitComponentEvent({ eventType: 'mousedown', el, originalEvent });
  },
  emitComponentEvent(_ref5) {var eventType = _ref5.eventType,el = _ref5.el,originalEvent = _ref5.originalEvent,index = _ref5.index;
    var checkedIndexes = this.getCheckedIndexes();
    var isCheckbox = this.type === 'checkbox';

    var eventObj = {
      el,
      originalEvent };


    if (isCheckbox && checkedIndexes.length > 1) {
      Object.assign(eventObj, {
        indexes: this.getCheckedIndexes(), // DEPRECATED in v5
        checked: this.getCheckedIndexes(), // DEPRECATED in v5 (keep but change from indexes to values)
        checkedValues: this.getCheckedValues() // DEPRECATED in v5
      });
    } else if (isCheckbox || this.isRadio()) {
      Object.assign(eventObj, {
        index, // DEPRECATED in v5
        checked: this.getCheckedIndexes(), // DEPRECATED in v5 (keep but change from indexes to values)
        checkedValues: this.getCheckedValues() // DEPRECATED in v5
      });
    } else if (eventType !== 'expand' && eventType !== 'collapse') {
      Object.assign(eventObj, {
        index, // DEPRECATED in v5
        checked: [index] // DEPRECATED in v5 (keep but change from indexes to values)
      });
    }

    this.emit("" + eventType, eventObj);
  },

  onInput(input) {
    this.state = this.getInputState(input);
  },

  onRender() {
    if (typeof window !== 'undefined') {
      this._cleanupMakeup();
    }
  },

  onMount() {
    this._setupMakeup();
  },

  onUpdate() {
    this._setupMakeup();
  },

  onDestroy() {
    this._cleanupMakeup();
  },

  _setupMakeup() {
    this.expander = new _makeupExpander.default(this.el, {
      hostSelector: '.menu-button__button',
      contentSelector: '.menu-button__menu',
      focusManagement: 'focusable',
      expandOnClick: true,
      autoCollapse: true,
      alwaysDoFocusManagement: true });

  },

  _cleanupMakeup() {
    if (this.expander) {
      this.expander.destroy();
    }
  } });exports.default = _default;module.exports = exports.default;